/* ==========================================================================
   Descena — ds-chat.js
   KI-Chat-Widget (Floating-Button unten LINKS + Panel). Unten rechts sitzt
   die gesetzliche Widerrufsfunktion — der Chat darf sie nie überdecken.
   Spricht mit dem Server-Proxy auf dem IONOS-Webspace; ohne erreichbaren
   Proxy fällt das Widget auf den Kontakt-Hinweis zurück.
   Kein Framework, keine Cookies — Verlauf nur im sessionStorage.
   KI-Kennzeichnung nach Art. 50 KI-VO (ab 02.08.2026): Hinweis in Kopfzeile,
   Begrüßung und Fußzeile — muss beim ersten Kontakt erkennbar bleiben.
   ========================================================================== */
(function () {
  "use strict";

  var ENDPOINT = "/apps/chat/message";  /* Shopify App Proxy -> IONOS-Backend (chat-descena/chat.php); Browser sieht nur descena.de */
  var VORGANG  = "/apps/chat/vorgang";  /* Mängelmeldung + Medien-Upload (chat-descena/vorgang.php) */
  var KEY = "ds-chat-verlauf";
  var FALLBACK = "Der Chat ist gerade nicht erreichbar. Schreib uns über das Kontaktformular (Link unten) oder an info@descena.de – wir melden uns schnell.";
  var verlauf = [];
  try { verlauf = JSON.parse(sessionStorage.getItem(KEY) || "[]"); } catch (e) {}

  /* ---------- Markup ---------- */
  var fab = document.createElement("button");
  fab.type = "button";
  fab.className = "ds-chat-fab";
  fab.setAttribute("aria-label", "Fragen zur Hühnertränke? KI-Chat öffnen");
  fab.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" width="22" height="22"><path fill="currentColor" d="M12 3C7.03 3 3 6.58 3 11c0 2.05.87 3.92 2.3 5.33-.15 1.15-.62 2.34-1.62 3.31-.2.2-.06.55.22.53 1.9-.15 3.42-.83 4.55-1.6 1.08.4 2.28.63 3.55.63 4.97 0 9-3.58 9-8s-4.03-8-9-8Z"/></svg><span class="ds-chat-fab__label">Fragen?</span>';

  var panel = document.createElement("div");
  panel.className = "ds-chat-panel";
  panel.setAttribute("role", "dialog");
  panel.setAttribute("aria-label", "Chat mit Descena");
  panel.hidden = true;
  panel.innerHTML =
    '<div class="ds-chat-kopf">' +
      '<div><strong>Descena</strong><span>KI-Assistent · antwortet automatisch</span></div>' +
      '<button type="button" class="ds-chat-zu" aria-label="Chat schließen">✕</button>' +
    '</div>' +
    '<div class="ds-chat-verlauf" aria-live="polite"></div>' +
    '<form class="ds-chat-form">' +
      '<label class="visually-hidden" for="ds-chat-eingabe">Deine Frage</label>' +
      '<input id="ds-chat-eingabe" type="text" maxlength="500" placeholder="z. B. Reicht die Tränke für 8 Hühner?" autocomplete="off">' +
      '<button type="submit" class="ds-chat-senden" aria-label="Frage senden"><svg viewBox="0 0 24 24" aria-hidden="true" width="18" height="18"><path fill="currentColor" d="M3.4 20.4 20.85 12 3.4 3.6 3.39 10l12.46 2L3.39 14z"/></svg></button>' +
    '</form>' +
    '<p class="ds-chat-fuss">KI-Assistent — kann sich irren; es gelten die Angaben auf der Produktseite. Bitte keine persönlichen Daten eingeben. <a href="/policies/privacy-policy">Datenschutz</a> · <a href="/pages/contact">Kontakt</a></p>';

  document.body.appendChild(fab);
  document.body.appendChild(panel);

  var verlaufEl = panel.querySelector(".ds-chat-verlauf");
  var eingabe = panel.querySelector("#ds-chat-eingabe");
  var form = panel.querySelector(".ds-chat-form");

  function zeile(rolle, text) {
    var el = document.createElement("div");
    el.className = "ds-chat-msg ds-chat-msg--" + rolle;
    /* Die serverseitigen Rechts-Bausteine sind mehrzeilig. textContent
       allein würde alles zu einem Absatz zusammenziehen; pre-line hält
       die Gliederung, ohne HTML aus der Antwort zu interpretieren. */
    el.style.whiteSpace = "pre-line";
    el.textContent = text;
    verlaufEl.appendChild(el);
    verlaufEl.scrollTop = verlaufEl.scrollHeight;
    return el;
  }

  function begruessung() {
    if (!verlauf.length && !verlaufEl.childElementCount) {
      zeile("assistant", "Hallo! Ich bin ein KI-Assistent, kein Mensch. Fragen zur Hühnertränke, zu Reinigung, Winter oder Versand? Frag mich einfach — für persönliche Anliegen schreib uns über den Kontakt-Link unten.");
    }
  }

  verlauf.forEach(function (m) { zeile(m.role === "assistant" ? "assistant" : "user", m.content); });

  function offen(o) {
    panel.hidden = !o;
    fab.classList.toggle("ds-chat-fab--offen", o);
    if (o) { begruessung(); eingabe.focus(); }
  }
  fab.addEventListener("click", function () { offen(panel.hidden); });
  panel.querySelector(".ds-chat-zu").addEventListener("click", function () { offen(false); fab.focus(); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !panel.hidden) { offen(false); fab.focus(); } });

  var wartet = false;
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var frage = eingabe.value.trim();
    if (!frage || wartet) { return; }
    eingabe.value = "";
    zeile("user", frage);
    verlauf.push({ role: "user", content: frage });

    var tipp = zeile("assistant", "…");
    tipp.classList.add("ds-chat-msg--tippt");
    wartet = true;

    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ messages: verlauf.slice(-8) })
    }).then(function (r) { return r.json(); }).then(function (d) {
      tipp.classList.remove("ds-chat-msg--tippt");
      var text = (d && d.text) ? d.text : FALLBACK;
      tipp.textContent = text;
      verlauf.push({ role: "assistant", content: text });
      try { sessionStorage.setItem(KEY, JSON.stringify(verlauf.slice(-16))); } catch (err) {}
      wartet = false;
      /* Der Server signalisiert die Vorgangsart. Erst dann erscheint der
         Einstieg ins Formular — nie unaufgefordert, nie vom Modell erfunden.
         'frage' ist der Wortlaut der Kundennachricht: Bei einem Widerruf
         ist genau der das Beweisstück, weil ein Widerruf formfrei ist. */
      if (d && d.aktion === "mangelmeldung")      { angebotVorgang("mangel",     d.upload_hinweis || "", frage); }
      else if (d && d.aktion === "widerrufserklaerung") { angebotVorgang("widerruf",   d.upload_hinweis || "", frage); }
      else if (d && d.aktion === "sicherheit")    { angebotVorgang("sicherheit", d.upload_hinweis || "", frage); }
    }).catch(function () {
      tipp.classList.remove("ds-chat-msg--tippt");
      tipp.textContent = FALLBACK;
      wartet = false;
    });
  });

  /* =======================================================================
     MÄNGELMELDUNG
     Ab hier formuliert kein Sprachmodell mehr. Das Formular ist fest
     verdrahtet, der Bestätigungstext kommt vom Server. Der Chat NIMMT AUF
     und gibt nichts frei — die Entscheidung über eine Rücksendung trifft
     Jonas persönlich (hält den Vorgang aus Art. 22 DSGVO heraus).
     ======================================================================= */

  /* Styles für das Vorgangs-Formular werden hier injiziert statt in
     ds-core.css gelegt. Grund: Damit ändert sich am Theme NUR diese eine
     Datei — der Rückweg ist ein einziger Datei-Tausch, und die 17-KB-CSS
     des Live-Themes wird nicht angefasst (dort arbeitet parallel eine
     andere Session). Die Werte stammen aus dem Design-System. */
  (function stile() {
    var s = document.createElement("style");
    s.textContent = [
      ".ds-chat-aktion{display:inline-block;margin-top:.6rem;padding:.9rem 1.4rem;min-height:4.4rem;",
      "background:var(--ds-brand-ink);color:#fff;border:0;border-radius:var(--ds-radius);cursor:pointer;",
      "font-family:var(--ds-sans);font-size:1.35rem;font-weight:600}",
      ".ds-chat-aktion:hover{background:var(--ds-pine-900)}",
      ".ds-chat-aktion:focus-visible{outline:3px solid var(--ds-brand);outline-offset:2px}",
      ".ds-chat-aktion[disabled]{opacity:.55;cursor:default}",
      ".ds-chat-mangelform{max-width:100%}",
      ".ds-chat-mangelform p{margin:0 0 1rem;font-size:1.3rem}",
      ".ds-chat-mangelform label{display:block;margin:.9rem 0 .3rem;font-size:1.2rem;font-weight:600;color:var(--ds-ink)}",
      ".ds-chat-mangelform input,.ds-chat-mangelform select,.ds-chat-mangelform textarea{width:100%;",
      "padding:.8rem 1rem;min-height:4.4rem;border:1px solid var(--ds-line);border-radius:var(--ds-radius);",
      "background:var(--ds-white,#fff);color:var(--ds-ink);font-family:var(--ds-sans);font-size:1.4rem}",
      ".ds-chat-mangelform textarea{min-height:8rem;resize:vertical}",
      ".ds-chat-mangelform input[type=file]{padding:.8rem;font-size:1.25rem}",
      ".ds-chat-mangelform input:focus-visible,.ds-chat-mangelform select:focus-visible,",
      ".ds-chat-mangelform textarea:focus-visible{outline:3px solid var(--ds-brand);outline-offset:1px}",
      /* Der Datenschutz-Hinweis steht ÜBER dem Dateifeld und muss lesbar bleiben. */
      ".ds-chat-hinweis{margin:1.2rem 0 .4rem!important;padding:.8rem 1rem;background:var(--ds-white,#fff);",
      "border-left:3px solid var(--ds-brand);font-size:1.2rem!important;line-height:1.45;color:var(--ds-ink-soft)}",
      ".ds-chat-status{margin:.8rem 0 0!important;font-size:1.25rem!important;color:var(--ds-ink-soft)}"
    ].join("");
    document.head.appendChild(s);
  })();

  var ARTEN = {
    mangel:     { knopf: "Mängelmeldung aufnehmen",     titel: "Ich nehme die Angaben auf und gebe sie an Jonas weiter. Er prüft den Fall persönlich und meldet sich per E-Mail.", was: "Was stimmt nicht?" },
    widerruf:   { knopf: "Widerrufserklärung aufnehmen", titel: "Ich halte deine Erklärung mit Datum und Uhrzeit fest und gebe sie an Jonas weiter. Eine Genehmigung braucht ein Widerruf nicht — das hier sichert nur den Eingang.", was: "Worauf bezieht sich dein Widerruf?" },
    sicherheit: { knopf: "Vorfall melden",               titel: "Ich nehme den Vorfall auf und leite ihn sofort an Jonas persönlich weiter.", was: "Was ist passiert?" }
  };

  function angebotVorgang(art, uploadHinweis, wortlaut) {
    if (verlaufEl.querySelector(".ds-chat-mangel")) { return; }   /* nur einmal */
    var box = document.createElement("div");
    box.className = "ds-chat-msg ds-chat-msg--assistant ds-chat-mangel";
    var knopf = document.createElement("button");
    knopf.type = "button";
    knopf.className = "ds-chat-aktion";
    knopf.textContent = ARTEN[art].knopf;
    knopf.addEventListener("click", function () { box.remove(); formularVorgang(art, uploadHinweis, wortlaut); });
    box.appendChild(knopf);
    verlaufEl.appendChild(box);
    verlaufEl.scrollTop = verlaufEl.scrollHeight;
  }

  function feld(wrap, art, name, beschriftung, pflicht, attrs) {
    var id = "ds-m-" + name;
    var l = document.createElement("label");
    l.setAttribute("for", id);
    l.textContent = beschriftung + (pflicht ? " *" : "");
    var i = document.createElement(art === "textarea" ? "textarea" : "input");
    i.id = id; i.name = name;
    if (art !== "textarea") { i.type = art; }
    if (pflicht) { i.required = true; }
    Object.keys(attrs || {}).forEach(function (k) { i.setAttribute(k, attrs[k]); });
    wrap.appendChild(l); wrap.appendChild(i);
    return i;
  }

  function formularVorgang(art, uploadHinweis, wortlaut) {
    var f = document.createElement("form");
    f.className = "ds-chat-msg ds-chat-msg--assistant ds-chat-mangelform";
    f.setAttribute("aria-label", ARTEN[art].knopf);
    var uploadAktiv = false; /* sicherer Standard: ohne bestätigte Serverfreigabe kein Dateiupload */

    var kopf = document.createElement("p");
    kopf.textContent = ARTEN[art].titel;
    f.appendChild(kopf);

    var eName    = feld(f, "text",     "name",          "Dein Name",     true,  { maxlength: "120", autocomplete: "name" });
    var eMail    = feld(f, "email",    "email",         "E-Mail",        true,  { maxlength: "160", autocomplete: "email" });
    var eBestell = feld(f, "text",     "bestellnummer", "Bestellnummer", false, { maxlength: "60", placeholder: "falls zur Hand" });
    var eText    = feld(f, "textarea", "beschreibung",  ARTEN[art].was,  true,  { maxlength: "1500", rows: "4" });

    /* Nacherfüllung: Der Käufer wählt zwischen Nachbesserung und
       Ersatzlieferung (§ 439 Abs. 1 BGB). Wir nehmen den Wunsch auf,
       ohne ihn zu bewerten — nur beim Mangel, nicht beim Widerruf. */
    var eWunsch = null;
    if (art === "mangel") {
      var lw = document.createElement("label");
      lw.setAttribute("for", "ds-m-wunsch");
      lw.textContent = "Was wünschst du dir?";
      eWunsch = document.createElement("select");
      eWunsch.id = "ds-m-wunsch";
      [["offen", "Noch offen – bitte beraten"],
       ["nachbesserung", "Reparatur"],
       ["ersatz", "Ersatzlieferung"]].forEach(function (o) {
        var opt = document.createElement("option");
        opt.value = o[0]; opt.textContent = o[1];
        eWunsch.appendChild(opt);
      });
      f.appendChild(lw); f.appendChild(eWunsch);
    }

    /* Die Medienfunktion wird vom Backend geschaltet. Dadurch lässt sie
       sich serverseitig vollständig pausieren, ohne Mängel-, Widerrufs-
       oder Sicherheitsmeldungen als Text zu blockieren. Standard ist AUS:
       Scheitert die Statusabfrage, erscheint kein Dateifeld. */
    var uploadBlock = document.createElement("div");
    uploadBlock.hidden = true;

    /* Der Upload-Hinweis MUSS vor dem Auswählen sichtbar sein — Fotos aus
       dem Hof enthalten sonst Personen und über EXIF die Wohnadresse. */
    var hinweis = document.createElement("p");
    hinweis.className = "ds-chat-hinweis";
    hinweis.textContent = uploadHinweis;
    uploadBlock.appendChild(hinweis);

    var lDatei = document.createElement("label");
    lDatei.setAttribute("for", "ds-m-dateien");
    lDatei.textContent = "Fotos oder kurzes Video (freiwillig, max. 4)";
    var eDatei = document.createElement("input");
    eDatei.type = "file"; eDatei.id = "ds-m-dateien"; eDatei.multiple = true;
    /* HEIC fehlt hier absichtlich: Der Server kann daraus die GPS-Daten
       nicht entfernen, verspricht das aber. Ohne HEIC im accept wandelt
       iOS die Fotos beim Upload selbst nach JPEG um. */
    eDatei.accept = "image/jpeg,image/png,image/webp,video/mp4,video/quicktime";
    uploadBlock.appendChild(lDatei); uploadBlock.appendChild(eDatei);

    var datenschutz = document.createElement("p");
    datenschutz.className = "ds-chat-status";
    datenschutz.appendChild(document.createTextNode("Details zu Speicherort, Zugriff und Löschung: "));
    var datenschutzLink = document.createElement("a");
    datenschutzLink.href = "/policies/privacy-policy";
    datenschutzLink.textContent = "Datenschutzerklärung";
    datenschutz.appendChild(datenschutzLink);
    uploadBlock.appendChild(datenschutz);
    f.appendChild(uploadBlock);

    var uploadPause = document.createElement("p");
    uploadPause.className = "ds-chat-hinweis";
    uploadPause.textContent = "Der Foto-/Video-Upload ist vorübergehend nicht verfügbar. Deine Meldung kannst du ohne Datei vollständig absenden.";
    f.appendChild(uploadPause);

    fetch(VORGANG + "?action=limits", { method: "GET" })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.upload_aktiv === true) {
          uploadAktiv = true;
          uploadBlock.hidden = false;
          uploadPause.hidden = true;
        }
      })
      .catch(function () {
        /* Fail closed: Textmeldung bleibt möglich, Dateifeld bleibt aus. */
      });

    var status = document.createElement("p");
    status.className = "ds-chat-status";
    status.setAttribute("aria-live", "polite");
    f.appendChild(status);

    var senden = document.createElement("button");
    senden.type = "submit";
    senden.className = "ds-chat-aktion";
    senden.textContent = "An Jonas senden";
    f.appendChild(senden);

    verlaufEl.appendChild(f);
    verlaufEl.scrollTop = verlaufEl.scrollHeight;
    eName.focus();

    f.addEventListener("submit", function (e) {
      e.preventDefault();
      if (senden.disabled) { return; }
      if (!eName.value.trim() || !eMail.value.trim() || !eText.value.trim()) {
        status.textContent = "Bitte Name, E-Mail und eine kurze Beschreibung ausfüllen.";
        return;
      }
      senden.disabled = true;
      status.textContent = "Wird übermittelt …";

      fetch(VORGANG + "?action=anlegen", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          art: art,
          name: eName.value.trim(),
          email: eMail.value.trim(),
          bestellnummer: eBestell.value.trim(),
          beschreibung: eText.value.trim(),
          wunsch: eWunsch ? eWunsch.value : "offen",
          wortlaut: wortlaut || ""
        })
      }).then(function (r) { return r.json(); }).then(function (v) {
        if (!v || !v.vorgang) { throw new Error(v && v.text ? v.text : "fehlgeschlagen"); }
        /* Dateien EINZELN nacheinander. Ein Request je Datei bleibt unter
           der ~20-MB-Grenze des Shopify App Proxy; mehrere Requests
           summieren sich trotzdem. Fehlschläge brechen die Meldung NICHT
           ab — der Upload ist freiwillig, der Text zählt. */
        var liste = uploadAktiv && v.upload_aktiv !== false
          ? Array.prototype.slice.call(eDatei.files || []).slice(0, v.max_anzahl || 4)
          : [];
        var kette = Promise.resolve();
        var fehlgeschlagen = 0;
        liste.forEach(function (datei, i) {
          kette = kette.then(function () {
            status.textContent = "Datei " + (i + 1) + " von " + liste.length + " wird geladen …";
            var fd = new FormData();
            fd.append("vorgang", v.vorgang);
            fd.append("token", v.token);
            fd.append("datei", datei);
            return fetch(VORGANG + "?action=datei", { method: "POST", body: fd })
              .then(function (r) { return r.json(); })
              .then(function (a) { if (!a || !a.ok) { fehlgeschlagen++; } })
              .catch(function () { fehlgeschlagen++; });
          });
        });
        return kette.then(function () {
          return fetch(VORGANG + "?action=abschliessen", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ vorgang: v.vorgang, token: v.token })
          }).then(function (r) { return r.json(); }).then(function (ab) {
            f.remove();
            zeile("assistant", (ab && ab.text) ? ab.text : ("Deine Meldung liegt unter der Nummer " + v.vorgang + " bei Jonas."));
            if (fehlgeschlagen) {
              zeile("assistant", fehlgeschlagen + " Datei(en) konnten wir nicht annehmen — meist sind sie zu groß. Deine Meldung ist trotzdem angekommen; du kannst Bilder gern noch an info@descena.de nachreichen.");
            }
          });
        });
      }).catch(function (err) {
        senden.disabled = false;
        status.textContent = (err && err.message) ? err.message : "Das hat nicht geklappt. Schreib uns bitte direkt an info@descena.de.";
      });
    });
  }
})();
